module.exports = __webpack_public_path__ + "static/media/policy_documents_manage.8edacc33.svg";